import { createAsyncThunk } from "@reduxjs/toolkit";
import { triggerAlert } from "redux/reducers/appSlice";
import ReservationsService from "services/reservations";
import {
  getGroupLessons,
  getIndividualCompletedLessons,
  getIndividualNotUsedLessons,
  getIndividualReservedLessons
} from "./studentLessons";
import {
  translateAPIMessage,
  translateFrontEndAlerts
} from "../../utils/translation";
import {
  IRatePayloadPack,
  IRatePayloadSingle
} from "../../types/redux/reservation";
import { getReservedLessons } from "./lessons";
import {
  getGroupLessonsStudentPayload,
  reservationActionPayload,
  submitReportPayload
} from "services/service-models/reservations";

export const getAllReservations = createAsyncThunk(
  "get-all-reservations",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const [individualReservations, groupReservations] = await Promise.all([
        ReservationsService.getIndividualReservations(data),
        ReservationsService.getGroupReservations(data)
      ]);

      return {
        individualReservations,
        groupReservations
      };
    } catch (err: any) {
      rejectWithValue(err);
    }
  }
);

export const getIndividualReservations = createAsyncThunk(
  "get/individualReservations",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      return await ReservationsService.getIndividualReservations(data);
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const getGroupReservations = createAsyncThunk(
  "get/groupReservations",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.getGroupReservations(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const approveSingleLesson = createAsyncThunk(
  "/approve/singleLesson",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.approveSingleLesson(data);
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18001)
        })
      );
      return res;
    } catch (err: any) {
      // return rejectWithValue(err);
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(
            err.response.data.errors.message as number
          )
        })
      );
      return false;
    }
  }
);

// * reject reservations - individual - single
export const rejectReservationIndividualSingle = createAsyncThunk(
  "/reject-reservations-individual-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.rejectReservationIndividualSingle(
        data
      );
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18002)
        })
      );
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);
// * reject reservations - individual - pack
export const rejectReservationIndividualPack = createAsyncThunk(
  "/reject-reservations-individual-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.rejectReservationIndividualPack(
        data
      );
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18003)
        })
      );
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);
// * reject reservations - group - single and pack
export const rejectReservationGroupSingleAndPack = createAsyncThunk(
  "/reject-reservations-group-single-and-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.rejectReservationGroupSingleAndPack(
        data
      );
      dispatch(getGroupReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18004)
        })
      );
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const approvePackLesson = createAsyncThunk(
  "/approve/packLesson",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.approvePackLesson(data);
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18005)
        })
      );
      return res;
    } catch (err: any) {
      // return rejectWithValue(err);
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(
            err.response.data.errors.message as number
          )
        })
      );
      return false;
    }
  }
);

// * student reservation - group - pack
export const studentReserveGroupPack = createAsyncThunk(
  "/student/reserve/group/pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.studentReserveGroupPack(data);
      // dispatch(triggerAlert({
      //   type: 'success',
      //   children: 'Reservation Complete'
      // }))
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(err.response.data.message as number)
        })
      );
      return false;
    }
  }
);
// * student reservation - group - single
export const studentReserveGroupSingle = createAsyncThunk(
  "/student/reserve/group/pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.studentReserveGroupSingle(data);
      // dispatch(triggerAlert({
      //   type: 'success',
      //   children: 'Reservation Complete'
      // }))
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(err.response.data.message as number)
        })
      );
      return false;
    }
  }
);

// * student reservation - individual - single
export const studentReserveIndividualSingle = createAsyncThunk(
  "/student/reserve/individual/single",
  async (data: any, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await ReservationsService.studentReserveIndividualSingle(
        data
      );
      // return fulfillWithValue('Reservation Complete !')
      // dispatch(triggerAlert({
      //   type: 'success',
      //   children: 'Reservation Complete'
      // }))
      return true;
    } catch (err: any) {
      // return rejectWithValue(err.response.data.errors.message);
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(err.response.data.message as number)
        })
      );
      return false;
    }
  }
);
// * student reservation - individual - single
export const studentReserveIndividualPack = createAsyncThunk(
  "/student/reserve/individual/pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.studentReserveIndividualPack(data);
      // dispatch(triggerAlert({
      //   type: 'success',
      //   children: 'Reservation Complete'
      // }))
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(err.response.data.message as number)
        })
      );
      return false;
    }
  }
);

// * get expert schedule
export const getExpertSchedule = createAsyncThunk(
  "/getExpertSchedule",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.getExpertSchedule(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);
// * get user total points
export const getUserTotalPoints = createAsyncThunk(
  "/get-user-total-points",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      return await ReservationsService.getUserTotalPoints();
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

// * send lesson report - individual - single
export const sendLessonReoprtIndividualSingle = createAsyncThunk(
  "/send-lesson-report-individual-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.sendLessonReoprtIndividualSingle(
        data
      );
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18006)
        })
      );
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);
// * send lesson report - group - single
export const sendLessonReoprtGroupSingle = createAsyncThunk(
  "/send-lesson-report-group-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.sendLessonReoprtGroupSingle(data);
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18006)
        })
      );
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);
// * send lesson report - group - pack
export const sendLessonReoprtGroupPack = createAsyncThunk(
  "/send-lesson-report-group-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.sendLessonReoprtGroupPack(data);
      dispatch(getIndividualReservations(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18006)
        })
      );
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);

// * get enrollments - group - single
export const getEnrollmentsGroupSingle = createAsyncThunk(
  "/get-enrollments-group-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.getEnrollmentsGroupSingle(data);
      return res.data;
    } catch (err: any) {
      rejectWithValue(err);
    }
  }
);
// * get enrollments - group - pack
export const getEnrollmentsGroupPack = createAsyncThunk(
  "/get-enrollments-group-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.getEnrollmentsGroupPack(data);
      return res.data;
    } catch (err: any) {
      rejectWithValue(err);
    }
  }
);

// * cancel reservations
export const cancelReservationGroupSingleAndPack = createAsyncThunk(
  "/cancel-reservations-group-single-and-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.cancelReservationGroupSingleAndPack(
        data
      );
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18007)
        })
      );
      dispatch(getGroupLessons());
      return res.data;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
    }
  }
);
export const cancelReservationIndividualSingle = createAsyncThunk(
  "/cancel-reservations-individual-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.cancelReservationIndividualSingle(
        data
      );
      dispatch(getIndividualReservedLessons());
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18007)
        })
      );
      return res.data;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
    }
  }
);
export const cancelReservationIndividualPack = createAsyncThunk(
  "/cancel-reservations-individual-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await ReservationsService.cancelReservationIndividualPack(
        data
      );
      dispatch(getGroupLessons());
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18007)
        })
      );
      dispatch(getIndividualReservedLessons());
      return res.data;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
    }
  }
);

// * reschedule reservations - individual - single
export const rescheduleIndividualSingle = createAsyncThunk(
  "/reschedule-individual-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      await ReservationsService.rescheduleIndividualSingle(data);
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);
// * reschedule reservations - individual - pack
export const rescheduleIndividualPack = createAsyncThunk(
  "/reschedule-individual-pack",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      await ReservationsService.rescheduleIndividualPack(data);
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);
// * refund reservations - individual - single
export const refundIndividualSingle = createAsyncThunk(
  "/refund-individual-single",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      await ReservationsService.refundIndividualSingle(data);
      dispatch(getIndividualNotUsedLessons());
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18008)
        })
      );
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);
// * refund reservations - individual - group
export const refundIndividualPack = createAsyncThunk(
  "/refund-individual-group",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      await ReservationsService.refundIndividuaGroup(data);
      dispatch(getIndividualNotUsedLessons());
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(18008)
        })
      );
      return true;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return false;
    }
  }
);
export const rateSingleReservation = createAsyncThunk(
  "/rateSingleReservation",
  async (
    data: IRatePayloadSingle,
    { rejectWithValue, dispatch, fulfillWithValue }
  ) => {
    try {
      const res = await ReservationsService.rateSingleReservation(data);
      dispatch(getIndividualCompletedLessons());
      dispatch(getGroupLessons());
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(27001)
        })
      );
      return fulfillWithValue(res);
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return rejectWithValue(err);
    }
  }
);
export const ratePackReservation = createAsyncThunk(
  "/ratePackReservation",
  async (
    data: IRatePayloadPack,
    { rejectWithValue, dispatch, fulfillWithValue }
  ) => {
    try {
      const res = await ReservationsService.ratePackReservation(data);
      dispatch(getIndividualCompletedLessons());
      dispatch(getGroupLessons());
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(27001)
        })
      );
      return fulfillWithValue(res);
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(err.response.data.errors.message as number) ||
            translateFrontEndAlerts(11001)
        })
      );
      return rejectWithValue(err);
    }
  }
);

// Teacher reservation

export const reservationScheduleChangeRequest = createAsyncThunk(
  "/reservation/scheduleChange/request",
  async (
    reservation_id: number,
    { rejectWithValue, dispatch, fulfillWithValue }
  ) => {
    try {
      const res = await ReservationsService.reservationScheduleChangeRequest(
        reservation_id
      );
      dispatch(getReservedLessons());
      return fulfillWithValue(res);
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(error?.response?.data?.errors?.message as number)
            || translateAPIMessage(error?.response?.data?.message as number)
            || translateFrontEndAlerts(11001)
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const teacherAcceptOrRejectReservation = createAsyncThunk(
  "/reservation/scheduleChange/request",
  async (
    data: reservationActionPayload,
    { rejectWithValue, dispatch, fulfillWithValue }
  ) => {
    try {
      const res = await ReservationsService.teacherAcceptOrRejectReservation(
        data
      );
      dispatch(getReservedLessons());
      return fulfillWithValue(res);
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(error?.response?.data?.errors?.message as number)
            || translateAPIMessage(error?.response?.data?.message as number)
            || translateFrontEndAlerts(11001)
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const teacherSubmitReport = createAsyncThunk(
  "/reservation/submit/report",
  async (
    data: submitReportPayload,
    { rejectWithValue, dispatch, fulfillWithValue }
  ) => {
    try {
      const res = await ReservationsService.teacherSubmitReport(data);
      dispatch(getReservedLessons());
      return fulfillWithValue(res);
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(error?.response?.data?.errors?.message as number)
            || translateAPIMessage(error?.response?.data?.message as number)
            || translateFrontEndAlerts(11001)
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getGroupLessonsReservationStudentList = createAsyncThunk(
  "group/reservation/students",
  async (data: getGroupLessonsStudentPayload, { dispatch }) => {
    try {
      const res =
        await ReservationsService.getGroupLessonsReservationStudentList(data);
      return res;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(
            err.response.data.errors.message as number
          )
        })
      );
      return [];
    }
  }
);
